import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import AppLayout from '@/components/AppLayout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import ReportsPage from '@/pages/ReportsPage';
import CompaniesPage from '@/pages/CompaniesPage';
import UsersPage from '@/pages/UsersPage';
import CustomersPage from '@/pages/CustomersPage';
import ProductsPage from '@/pages/ProductsPage';
import CategoriesPage from '@/pages/CategoriesPage';
import TicketsPage from '@/pages/TicketsPage';
import TicketDetailPage from '@/pages/TicketDetailPage';
import ProfilePage from '@/pages/ProfilePage';
import SuperAdminDashboard from '@/pages/SuperAdminDashboard';
import EmailLogsPage from '@/pages/EmailLogsPage';
import EmailTemplatesPage from '@/pages/EmailTemplatesPage';
import PublicPortalPage from '@/pages/PublicPortalPage';
import PublicTicketListPage from '@/pages/PublicTicketListPage';
import PublicTicketDetailPage from '@/pages/PublicTicketDetailPage';
import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Toaster richColors position="top-right" />
          <Routes>
          {/* Public Routes */}
          <Route path="/consulta" element={<PublicPortalPage />} />
          <Route path="/consulta/cnpj/:cnpj" element={<PublicTicketListPage />} />
          <Route path="/consulta/protocolo/:protocol" element={<PublicTicketDetailPage />} />
          <Route path="/consulta/ticket/:protocol" element={<PublicTicketDetailPage />} />
          
          {/* Auth Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/super-admin" element={<ProtectedRoute roles={['SUPER_ADMIN']}><SuperAdminDashboard /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute roles={['SUPER_ADMIN','ADMIN']}><ReportsPage /></ProtectedRoute>} />
            <Route path="/companies" element={<ProtectedRoute roles={['SUPER_ADMIN']}><CompaniesPage /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute roles={['SUPER_ADMIN','ADMIN']}><UsersPage /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute roles={['SUPER_ADMIN','ADMIN','SUPERVISOR','ATTENDANT']}><CustomersPage /></ProtectedRoute>} />
            <Route path="/products" element={<ProtectedRoute roles={['SUPER_ADMIN','ADMIN','SUPERVISOR']}><ProductsPage /></ProtectedRoute>} />
            <Route path="/categories" element={<ProtectedRoute roles={['SUPER_ADMIN','ADMIN','SUPERVISOR']}><CategoriesPage /></ProtectedRoute>} />
            <Route path="/tickets" element={<TicketsPage />} />
            <Route path="/tickets/:id" element={<TicketDetailPage />} />
            <Route path="/email-logs" element={<ProtectedRoute roles={['SUPER_ADMIN','ADMIN']}><EmailLogsPage /></ProtectedRoute>} />
            <Route path="/email-templates" element={<ProtectedRoute roles={['SUPER_ADMIN']}><EmailTemplatesPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
